import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { ProcessEntity } from '../../../../../../common/enums/processEntity';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { FormDivider, FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfessionalSummaryDataRead } from '../../../professionalSummaryData/ProfessionalSummaryDataRead';
import { Osasc1V1DiagnosticReportSummary } from '../../OSASC1/v1/Osasc1V1DiagnosticReportSummary';
import { MedicationsRead } from '../../utils/v1/medications/MedicationsRead';
import { TxcsMedicationsList } from '../../utils/v1/TxcsMedicationsList';

export function RequestSummaryKsyosMedicalCenter(props: ICustomControlRequestReadProps) {
    return (
        <>
            {props.request.customControlData.hoofdklacht && (
                <HorizontalFormGroupRead>
                    <FormLabel>Hoofdklacht</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.request.customControlData.hoofdklacht}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.request.customControlData.voorgeschiedenis && (
                <HorizontalFormGroupRead>
                    <FormLabel>Voorgeschiedenis</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.request.customControlData.voorgeschiedenis}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {(props.request.customControlData.hoofdklacht || props.request.customControlData.voorgeschiedenis) && (
                <FormDivider />
            )}

            <MedicationsRead
                entity={ProcessEntity.request}
                entityId={props.request.id}
                patientUsesMedication={props.request.patientUsesMedication}
            />

            <ProfessionalSummaryDataRead request={props.request} />

            <TxcsMedicationsList requestId={props.request.id} />

            {props.request.status === RequestStatus.draft && props.request.customControlData.consult && (
                <Osasc1V1DiagnosticReportSummary
                    customControlData={props.request.customControlData.consult}
                    isOpen={props.itemState.isOpen}
                />
            )}
        </>
    );
}
